import { Table, Text } from "@mantine/core";
import { formatDate, formatNZD } from "common/utils";
import React from "react";
import { AgedTrialBalance } from "types/model.types";

interface AgedTrialBalanceTransactionViewProps {
  debtor: AgedTrialBalance;
}
const AgedTrialBalanceTransactionView: React.FC<
  AgedTrialBalanceTransactionViewProps
> = ({ debtor }) => {
  return (
    <>
      {/* Debtor Summary */}
      <Text fw={600} size="lg" mb="sm">
        {debtor.surname} (ID: {debtor.id})
      </Text>

      <Table withColumnBorders withRowBorders key={debtor.id}>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Opening</Table.Th>
            <Table.Th>Current</Table.Th>
            <Table.Th>1 Month</Table.Th>
            <Table.Th>2 Months</Table.Th>
            <Table.Th>3 Months</Table.Th>
            <Table.Th>Balance</Table.Th>
            <Table.Th>Sales MTD</Table.Th>
            <Table.Th>GST MTD</Table.Th>
          </Table.Tr>
        </Table.Thead>

        <Table.Tbody>
          <Table.Tr>
            <Table.Td>{formatNZD(debtor.opening)}</Table.Td>
            <Table.Td>{formatNZD(debtor.currentMonth)}</Table.Td>
            <Table.Td>{formatNZD(debtor.month1)}</Table.Td>
            <Table.Td>{formatNZD(debtor.month2)}</Table.Td>
            <Table.Td>{formatNZD(debtor.month3)}</Table.Td>
            <Table.Td>{formatNZD(debtor.balance)}</Table.Td>
            <Table.Td>{formatNZD(debtor.salesMTD)}</Table.Td>
            <Table.Td>{formatNZD(debtor.gstMTD)}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td colSpan={8}>
              <Table
                striped
                highlightOnHover
                withColumnBorders
                withRowBorders
                stickyHeader
              >
                <colgroup>
                  <col style={{ width: "120px" }} />
                  <col style={{ width: "120px" }} />
                  <col style={{ width: "120px" }} />
                  <col style={{ width: "120px" }} />
                  <col style={{ width: "120px" }} />
                </colgroup>

                <Table.Thead>
                  <Table.Tr>
                    <Table.Th>Date</Table.Th>
                    <Table.Th>Type</Table.Th>
                    <Table.Th className="money">Debit</Table.Th>
                    <Table.Th className="money">Credit</Table.Th>
                    <Table.Th className="money">Ref</Table.Th>
                  </Table.Tr>
                </Table.Thead>

                <Table.Tbody>
                  {debtor.transactions.map((tx, index) => (
                    <Table.Tr key={index}>
                      <Table.Td>{formatDate(tx.createdOn)}</Table.Td>
                      <Table.Td>{tx.type2}</Table.Td>
                      <Table.Td className="money">
                        {formatNZD(tx.debit)}
                      </Table.Td>
                      <Table.Td className="money">
                        {formatNZD(tx.credit)}
                      </Table.Td>
                      <Table.Td className="money">{tx.ref}</Table.Td>
                    </Table.Tr>
                  ))}
                </Table.Tbody>
              </Table>
            </Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </>
  );
};

export default AgedTrialBalanceTransactionView;
